import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { setHeader, addReport } from '../actions'
import dateFormat from 'dateformat'

class ReportForm extends Component {
  componentWillMount() {
    // Set header
    const { setHeader, initialize, uid } = this.props
    setHeader({
      title: "日報投稿",
      left: {
        text: 'back',
        url: "/"
      },
      right: null
    })

    // Set date
    const now = new Date()
    var yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
    const date = (now.getHours() < 11)? dateFormat(yesterday, "yyyy-mm-dd") : dateFormat(now, "yyyy-mm-dd")
    initialize({
      uid,
      date
    })
  }
  render() {
    const { handleSubmit, addReport } = this.props
    return (
      <div className="report-form content">
        <form onSubmit={handleSubmit(values => addReport(values))} >
          <Field name="uid" component="input" type="hidden" />
          <div className="field">
            <div className="control has-icons-left">
              <Field name="date" component="input" type="date" className="input" />
              <span className="icon is-small is-left">
                <i className="far fa-calendar-alt"></i>
              </span>
            </div>
          </div>
          <div className="field">
            <div className="control">
              <Field name="text" component="textarea" className="textarea" />
            </div>
          </div>
          <div className="field">
            <label className="label">気分</label>
            <div className="control">
              <label className="radio"><Field name="feeling" component="input" type="radio" value="0"/> 最悪</label>
              <label className="radio"><Field name="feeling" component="input" type="radio" value="1"/> 悪い</label>
              <label className="radio"><Field name="feeling" component="input" type="radio" value="2"/> 少し悪い</label>
              <label className="radio"><Field name="feeling" component="input" type="radio" value="3"/> 少し良い</label>
              <label className="radio"><Field name="feeling" component="input" type="radio" value="4"/> 良い</label>
              <label className="radio"><Field name="feeling" component="input" type="radio" value="5"/> 最高</label>
            </div>
          </div>
          <div className="is-clearfix">
            <button type="submit" className="button is-pulled-right">送 信</button>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(
  state => ({ uid: state.user.uid }),
  { setHeader, addReport }
)(reduxForm({ form: 'report' })(ReportForm))


// WEBPACK FOOTER //
// ./src/components/ReportForm.js